<template>
  <div style='height: 100%'>
    <span>该功能暂未开放</span>
  </div>
</template>

<script>
export default {
  name: 'OfflineQRCodeImport',
  components: {
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
  },

  methods: {
  }
}
</script>
